import axios from "../axiosPlugin.js";

// export const getAccountingReportList = (data = {}, loading = false, isDefaultAlertTips = false) => {
//   const _data = Object.keys(data).map(key => `${key}=${data[key]}`).join("&");
//   // return axios({
//   //   url: `/api/monthClose/list?${_data}`,
//   //   method: "get",
//   //   data: {
//   //     loading,
//   //     isDefaultAlertTips,
//   //   },
//   // });

//   return {
//     "data": {
//       "count": 2,
//       "data": [
//         {
//           approve: true,
//           brandId: "60dd8a57a89e4f2560732bdb",
//           canDelete: true,
//           cinemaBrandName: "清远大剧院",
//           cinemaId: "616d45eec7c0db1c7425ec09",
//           createTime: 1634787297987,
//           id: "6170dfe174cb401b15f603e9",
//           lastUpdateTime: 1634787297987,
//           month: 1633014000000,
//           monthString: "2021-10",
//           operationId: "60dd8a5778401d7ec84a54c9",
//           operationName: "GZbrand",
//           status: "active",
//           type: "cinema"
//         },
//         {
//           approve: true,
//           brandId: "60dd8a57a89e4f2560732bdb",
//           canDelete: true,
//           cinemaBrandName: "LD大剧院",
//           cinemaId: "60dd8c52a89e4f2560732be2",
//           createTime: 1634809261194,
//           id: "617135addebec87cf148a5ce",
//           lastUpdateTime: 1634809261194,
//           month: 1622473200000,
//           monthString: "2021-06",
//           operationId: "60dd8c5278401d7ec84a54cc",
//           operationName: "LDcinema",
//           status: "active",
//           type: "cinema"
//         }
//       ],
//       "page": 0,
//       "pageSize": 10
//     },
//     "error": null,
//     "message": null,
//     "success": true
//   };
// };

// export const getAccountingReport = (data = {}, loading = false, isDefaultAlertTips = false) => {
//   const _data = Object.keys(data).map(key => `${key}=${data[key]}`).join("&");
//   // return axios({
//   //   url: `/api/monthClose/list?${_data}`,
//   //   method: "get",
//   //   data: {
//   //     loading,
//   //     isDefaultAlertTips,
//   //   },
//   // });

//   return {
//     "data":
//       {
//         theaterId: ["616d45eec7c0db1c7425ec09", "611a10cfd31bd96eebc5ee32", "6176541f70cc2969f29aad6c"],
//         selectMonth: 1633014000000,
//         reportDownload: [1, 3]
//       },
//     "error": null,
//     "message": null,
//     "success": true
//   };
// };

// export const createAccountingReport = (all = false, data = {}) => {
//   const url = all ? "/api/monthClose/create?all=ALL" : "/api/monthClose/create";
//   return axios({
//     url: url,
//     method: "post",
//     data: { data },
//   });
// };

// export const approveAccountingReport = (loading = false, isDefaultAlertTips = false) => {
// //   return axios({
// //     url: "/api/monthClose/approve",
// //     method: "get",
// //     data: {
// //       loading,
// //       isDefaultAlertTips
// //     },
// //   });
// // };
//   return {
//     data: {
//       success: true
//     }
//   };
// };

// export const deleteAccountingReport = (data, loading = false, isDefaultAlertTips = false) => {
//   const _data = Object.keys(data).map(key => `${key}=${data[key]}`).join("&");
//   // return axios({
//   //   url: `/api/monthClose/delete?${_data}`,
//   //   method: "get",
//   //   data: {
//   //     loading,
//   //     isDefaultAlertTips,
//   //   },
//   // });
//   return {
//     data: {
//       success: true
//     }
//   };

// };

export const getAccountingReportList = data => {
  return axios({
    url: "/api/accounting/list",
    method: "get",
    data: {
      data,
    },
  });
};

export const approveAccountingReport_fn = () => {
  return axios({
    url: "/api/accounting/approve",
    method: "get",
    data: {}
  });
};

export const createAccountingReport_fn = data => {
  return axios({
    url: "/api/accounting/create",
    method: "post",
    data: {
      data,
    },
  });
};

export const removeAccountingReport_fn = data => {
  return axios({
    url: `/api/accounting/delete/${data.id}`,
    method: "get",
    data: {},
  });
};

export const exportAccountingReport_fn = data => {
  return axios({
    url: "/api/accounting/export",
    method: "get",
    data: {
      data
    }
  });
};

export const AccountingReportDetail_fn = data => {
  return axios({
    url: `/api/accounting/detail/${data.id}`,
    method: "get",
    data: {
      data
    }
  });
};